// Animation des textes de chargement : tout élément dont le texte est « Chargement… », « Chargement des … »,
// « Envoi… », « Enregistrement… », « Préparation… » (ou leur équivalent anglais) reçoit la classe
// `hb-loading-text`. Les blocs de chargement (« Chargement… », « Import… », « Préparation… » hors boutons et
// cellules de tableau) deviennent `hb-brand-loading` : seul le nom Hubimmo animé s'affiche (animations.css).
const LOADING_RE = /^(chargement|loading|envoi|sending|enregistrement|saving|préparation|preparing|calcul|import|génération|generating|traitement|processing|connexion|signing in|vérification|checking|recherche|searching)\b[^.]{0,60}(…|\.\.\.)$/i;
const SKIP = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'OPTION', 'SELECT', 'TITLE']);
// Chargement de contenu (pas une action d'envoi ou d'enregistrement)
const CONTENT_RE = /^(chargement|loading|import|préparation|preparing|génération|generating|traitement|processing|calcul|recherche|searching)/i;
// Éléments en ligne ou de tableau : le texte reste (le nom animé s'affiche dans la pastille globale)
const INLINE = new Set(['TD', 'TH', 'BUTTON', 'A', 'LABEL', 'SPAN', 'SMALL', 'STRONG', 'EM', 'B', 'I', 'LI', 'OPTION']);

function refresh(el) {
  if (!el || el.nodeType !== 1 || SKIP.has(el.nodeName)) return;
  // Éléments qui ont déjà leur propre animation
  if (el.closest('.hb-loading-block, .loading-screen, #hb-loading-pill, div.loading, .hb-boot')) return;
  const text = (el.textContent || '').trim();
  const loading = text.length < 90 && LOADING_RE.test(text) && el.children.length <= 2;
  // Un conteneur dont le seul contenu est un bloc de chargement n'est pas lui-même un bloc de chargement
  // (sinon il reste centré une fois la page affichée : contenu décalé et coupé à gauche)
  const brand = loading && CONTENT_RE.test(text) && !INLINE.has(el.nodeName) && !el.closest('button, td, th')
    && !el.querySelector('div.loading, .hb-brand-loading, .hb-loading-block, .loading-screen');
  el.classList.toggle('hb-brand-loading', brand);
  el.classList.toggle('hb-loading-text', loading && !brand);
  if (brand) el.setAttribute('role', el.getAttribute('role') || 'status');
}

function scan(root) {
  if (root.nodeType === 3) { refresh(root.parentElement); return; }
  if (root.nodeType !== 1) return;
  refresh(root);
  const it = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  for (let n = it.nextNode(); n; n = it.nextNode()) {
    const t = n.nodeValue.trim();
    if (t && (LOADING_RE.test(t) || n.parentElement?.classList.contains('hb-loading-text') || n.parentElement?.classList.contains('hb-brand-loading'))) refresh(n.parentElement);
  }
}

let observer = null;
export function installLoadingDecorator() {
  if (observer || typeof window === 'undefined' || typeof MutationObserver === 'undefined') return;
  const start = () => {
    scan(document.body);
    observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'characterData') refresh(m.target.parentElement);
        else {
          // Contenu remplacé dans un bloc de chargement : la classe est retirée (sinon la page reste centrée et coupée)
          if (m.target?.classList?.contains('hb-loading-text') || m.target?.classList?.contains('hb-brand-loading')) refresh(m.target);
          const block = m.target?.parentElement?.closest?.('.hb-brand-loading');
          if (block) refresh(block);
          m.addedNodes.forEach(scan);
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
}
